import React from "react";
const FlagDE = () => (
    <svg width="29" height="19" viewBox="0 0 29 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1877_5693)">
            <path d="M29 0H0.5V19H29V0Z" fill="black" />
            <path d="M29 6.33398H0.5V19.0001H29V6.33398Z" fill="#FF0000" />
            <path d="M29 12.666H0.5V18.9999H29V12.666Z" fill="#FCC500" />
        </g>
        <defs>
            <clipPath id="clip0_1877_5693">
                <rect x="0.5" width="28.5" height="19" rx="2" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
export default FlagDE;
